import PropTypes from 'prop-types'

import { Stack, Typography } from '@mui/material'

import { VisualizationModal, CleanButton } from '../default'

const BatchFileInfoModal = ({ open, onClose }) => {

    return (
        <VisualizationModal
            open={open} onClose={onClose}
            title='Dúvidas sobre a formatação do arquivo CSV'
        >
            <Stack gap={2}>

                <Typography><strong>1)</strong> O arquivo CSV que será importado deve incluir o histórico de pedidos dos últimos 6 meses de todos os clientes que terão o limite de crédito atualizado.</Typography>
                <Typography><strong>2)</strong> No arquivo, cada linha representa um boleto emitido e deve ser composta pelos seguintes atributos:</Typography>

                <Stack gap={0.5} ml={2.5}>
                    <Typography><strong>cliente_code:</strong> CNPJ do cliente.</Typography>
                    <Typography><strong>current_limit:</strong> valor do limite de crédito atual do cliente.</Typography>
                    <Typography><strong>consumed_limit:</strong> valor do limite de crédito utilizado pelo cliente.</Typography>
                    <Typography><strong>order_id:</strong> identificador do pedido.</Typography>
                    <Typography><strong>seller_id:</strong> identificador do vendedor que realizou o pedido.</Typography>
                    <Typography><strong>ticket_id:</strong> identificador do boleto.</Typography>
                    <Typography><strong>amount:</strong> valor do boleto.</Typography>
                    <Typography><strong>created_at:</strong> data de criação do boleto.</Typography>
                    <Typography><strong>due_to:</strong> data de vencimento do boleto.</Typography>
                    <Typography><strong>payment_at:</strong> data de pagamento do boleto. Caso o boleto não tenha sido pago, deve ser null.</Typography>
                </Stack>

                <Typography><strong>3)</strong> A vírgula (,) deve ser usada como separador de atributos e o ponto (.) como separador decimal.</Typography>

                <Typography><strong>4)</strong> Em caso de dúvidas, baixe o arquivo template abaixo:</Typography>

                <CleanButton
                    label='Baixar Template CSV'
                    download='template.csv'
                    href='/batch_file_template.csv'
                    onClick={onClose}
                />
            </Stack>
        </VisualizationModal>
    )

}

BatchFileInfoModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
}

export default BatchFileInfoModal